import { useNavigate } from "react-router-dom";
import {
  AlertDialog, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

interface TrialExpiryDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function TrialExpiryDialog({ open, onOpenChange }: TrialExpiryDialogProps) {
  const navigate = useNavigate();

  const handleSubscribe = () => {
    onOpenChange(false);
    navigate("/settings?tab=plan");
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="sm:max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-xl">Your free trial has ended</AlertDialogTitle>
          <AlertDialogDescription className="text-base">
            Subscribe to keep full access to Easy Rental. Choose a plan in Settings to continue.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col gap-2 sm:flex-row">
          <Button className="w-full sm:w-auto" onClick={handleSubscribe}>
            Subscribe Now
          </Button>
          <Button variant="ghost" className="w-full sm:w-auto" onClick={() => onOpenChange(false)}>
            Maybe Later
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
